import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import residentPostalPageData from '../data/servicePages/residentPostal';

const ResidentPostalPage = () => <ServicePageLayout data={residentPostalPageData} />;

export default ResidentPostalPage;
